import React from "react";
import moment from "moment";

const ForecastUpdatesContainer = ({ activeData }): JSX.Element => {
  return (
    <div className="updates-container">
      {activeData?.getActiveForecast?.createdAt ? (
        <span style={{ marginTop: "1rem", color: "lightgray" }}>
          <br />
          Created at `
          {moment(activeData.getActiveForecast.createdAt).format(
            "MMMM Do YYYY, h:mm:ss a"
          )}
          ` by `{activeData.getActiveForecast.createdBy}`
        </span>
      ) : (
        <div style={{ padding: "1rem" }}></div>
      )}
      {activeData?.getActiveForecast?.updatedAt ? (
        <span style={{ marginTop: "1rem", color: "lightgray" }}>
          <br />
          Updated at `
          {moment(activeData.getActiveForecast.updatedAt).format(
            "MMMM Do YYYY, h:mm:ss a"
          )}
          ` by `{activeData.getActiveForecast.updatedBy}`
        </span>
      ) : (
        <div style={{ margin: "1rem" }}></div>
      )}
    </div>
  );
};

export default ForecastUpdatesContainer;
